import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  Link 
} from '@mui/material';

const AboutDialog = ({ aboutOpen, setAboutOpen }) => {
  return (
    <Dialog open={aboutOpen} onClose={() => setAboutOpen(false)}>
      <DialogTitle>
        <Typography variant="h4" component="div" gutterBottom sx={{ fontFamily: 'Courier New, monospace' }}>
          About EvilNodes
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ marginBottom: 2, fontFamily: 'Courier New, monospace' }}>
          Evil Nodes simplifies the visualization of complex relationships within security logs by applying graph theory. 
          By turning datasets into interactive graphs, this app helps uncover hidden dependencies and cascading connections, 
          such as compromised identities and downstream impacts. Key features include support for Closed Neighborhood and 
          Breadth-First Search (BFS), intuitive node exploration, and customizable searches.
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2, fontFamily: 'Courier New, monospace' }}>
          For more information, visit the <Link href="https://github.com/dmdund/evilnodes" target="_blank" rel="noopener">GitHub</Link> page.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setAboutOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AboutDialog;